import React from "react";

import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

const RawScoresRow = props => {
  const { modelScores, scoreDate } = props;
  return (
    <TableRow hover>
      <TableCell>{scoreDate}</TableCell>
      {modelScores.map(s => (
        <TableCell key={s.model_id}>{s.score_value}</TableCell>
      ))}
    </TableRow>
  );
};

export default RawScoresRow;
